import { FC, useMemo } from "react";
import { ClientBalance } from "../../../../../shared/interfaces/services/client-balance";
import { CardRender } from "../../../../../shared/components/CardRender";
import { formattedPrice } from "../../../../../shared/utils";
import { Intermediary } from "../../../../../shared/interfaces";
import userHelper from "../../../../../shared/utils/userHelper";

interface ClientBalanceCardProps {
  clientBalance: ClientBalance;
  selectedProducer: Intermediary | undefined;
  loading?: boolean;
}

export const ClientBalanceCard: FC<ClientBalanceCardProps> = ({
    clientBalance,
    loading,
    selectedProducer
}) => {
  const userInfo = userHelper.getUser();    
    const {
        importeSaldo,
        condicionSaldo,

      } = clientBalance;
    
    const columnsDataClaim = useMemo(() => [
        {
          label: 'Cuenta Corriente',
          value:  selectedProducer ? `${selectedProducer?.codMayorAux}-${selectedProducer?.nroMayorAux}` : `${userInfo?.intermediarioSecundario?.codMayorAux}-${userInfo?.intermediarioSecundario?.nroMayorAux}`,
        },
        {
          label: 'Saldo',
          value: `$ ${formattedPrice(importeSaldo || '0')}`,
        },
        {
          label: 'Condición',
          value: condicionSaldo,
        },
      ],
      [
        userInfo,
        selectedProducer,
        importeSaldo,
        condicionSaldo,
      ]
    );

    return (
        <CardRender
          title={''}
          loading={loading}
          columnsData={columnsDataClaim}
        />
      );
}